import React, {Component} from 'react'
import * as colors from '../colors'
import {style, media, merge} from 'glamor'
import { Media, Player, controls } from 'react-media-player'
const { PlayPause, MuteUnmute, } = controls
import ButtonPlayPause from './ButtonPlayPause'
import Progress from './Progress'

export default class Video extends Component {

  render(){
    console.log(this.props.src)
    return (

      <Media>
       <div
       {...style({
         width: '100%',
         minHeight: '100px',
         position: 'relative',
         background: colors.black
       })}
       >
         <div className="media-player"
         {...style({
           width: '100%',
           position: 'relative'
         })}
         >
           <Player style={{
             width: '100%',
             display: 'block',
           }} src={this.props.src}/>
         </div>
         <ButtonPlayPause/>
         <div
          {...style({
            position: 'absolute',
            zIndex: 1,
            bottom: 0,
            left: 0,
            width: '100%',
          })}
         >
           <Progress/>
         </div>
       </div>
     </Media>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Video.js
 **/